import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/style.css"; // Importa o CSS personalizado
import "bootstrap/dist/css/bootstrap.min.css"; // Importa o Bootstrap

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
